(function () {
  /**
   * @ngdoc module
   * @name binky.core.common.list.state.alpha
   * @description module defining abstract Alpha List model
   */
  angular.module('binky.core.common.list.state.alpha', [
    'binky.core.api.jil',
    'binky.core.common.model.cache',
  ]);
})();
